import { render, staticRenderFns } from "./Caregiverexclusive.vue?vue&type=template&id=4902358f"
import script from "./Caregiverexclusive.vue?vue&type=script&lang=js"
export * from "./Caregiverexclusive.vue?vue&type=script&lang=js"
import style0 from "./Caregiverexclusive.vue?vue&type=style&index=0&id=4902358f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports